import React, { lazy, Suspense, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import { CalculatorProvider } from './context/CalculatorContext';
import CookieConsent from './components/common/CookieConsent';
import { useTranslation } from 'react-i18next';

const Home = lazy(() => import('./components/pages/Home'));

const TradingPage = lazy(() => import('./components/pages/TradingPage'));
const StakingPage = lazy(() => import('./components/pages/StakingPage'));
const ThorchainPage = lazy(() => import('./components/pages/ThorchainPage'));
const About = lazy(() => import('./components/pages/About'));

const PrivacyPolicy = lazy(() => import('./components/pages/PrivacyPolicy'));
const Cookies = lazy(() => import('./components/pages/Cookies'));


const ScrollToTop = () => {
    const { pathname } = useLocation();
  
    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);

    return null;
  }


const App: React.FC = () => {
    const { i18n } = useTranslation();
  
  useEffect(() => {
    const savedLanguage = localStorage.getItem('i18nextLng');
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage);
    }
  }, [i18n]);

  return (
    <CalculatorProvider>
      <Router>
        <ScrollToTop />
        <Layout>
          <Suspense fallback={<div className="flex justify-center items-center h-screen">Loading...</div>}>
            <Routes>
              <Route path="/" element={<Home />} />

              <Route path="/about" element={<About />} />

              <Route path="/products/trading" element={<TradingPage />} />
              <Route path="/products/staking" element={<StakingPage />} />
              <Route path="/products/thorchain" element={<ThorchainPage />} />

              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/cookies" element={<Cookies />} />

              <Route path="*" element={<div className="text-center py-40">Страница не найдена</div>} />
            </Routes>
          </Suspense>
        </Layout>
      </Router>
      <CookieConsent />
    </CalculatorProvider>
  );
};

export default App;